import { Routes } from '@angular/router';
import { loggedGuard, notLoggedGuard } from '@authGuard';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.routes').then(m => m.PagesRoutes)
      },
      {
        path: '',
        canActivate: [loggedGuard],
        loadChildren: () => import('./users/users.routes').then(m => m.UserRoutes)
      },
      {
        path: '',
        canActivate: [notLoggedGuard],
        loadChildren: () => import('./auth/auth.routes').then(m => m.AuthRoutes)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    pathMatch: 'full'
  },
  {
    path: 'round-view',
    loadComponent: () => import('./modal/hole/hole.component').then(m => m.HoleComponent),
    pathMatch: 'full'
  },
  {
    path: 'hole-view',
    loadComponent: () => import('./modal/hole/hole.component').then(m => m.HoleComponent),
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full'
  }
];
